import React, { useEffect, useState } from "react"
import Page from "../../common/page/Page"
import { useSelector, useDispatch } from "react-redux"
import { addToCart } from "../../data/CartSlice"
import axios from "axios"
import ProductCards from "../../common/ProductCards/ProductCards"
import Loader from "../../common/loader/Loader"
import { useAuth } from "../../data/useAuth"
import { useNavigate } from "react-router-dom"
import { useFlashMessage } from "../../common/hook/useFlashMessage"
import FlashMessage from "../../common/FlashMesage/FlashMessage"
// import { useOrderPayment } from "../../common/hook/useOrderPayment"

const Landing = () => {
  // const { initiatePayment } = useOrderPayment()
  const dispatch = useDispatch()
  const { flash, showMessage, hideMessage } = useFlashMessage()
  const search = useSelector((state) => state.global.search)
  const { isLoggedIn } = useAuth()
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  // const [selectProduct, setSelectProduct] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("/api/products")
        setProducts(response.data.products || [])
        console.log("Products fetched:", response.data.products)
        setLoading(false)
      } catch (err) {
        setError(err.response?.data?.message || err.message)
        setLoading(true)
      }
    }

    fetchProducts()
  }, [])
  return (
    <>
      <Page title={"Home"}>
        <div style={{ backgroundColor: "#f8fafc", minHeight: "100vh", padding: "20px 16px" }}>
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto 24px auto",
              background: "linear-gradient(135deg, #21170e 0%, #3d2b1a 100%)",
              borderRadius: "20px",
              padding: "32px 24px",
              color: "#ffffff",
              boxShadow: "0 10px 25px rgba(33, 23, 14, 0.15)",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <span style={{ fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.1em", opacity: 0.8, fontWeight: 600 }}>
              Natural & Authentic Wellness
            </span>
            <h1 style={{ fontSize: "1.8rem", fontWeight: 800, margin: 0, letterSpacing: "-0.02em" }}>
              Dr. Malu Mahendran's Herbal Products
            </h1>
            <p style={{ fontSize: "0.95rem", opacity: 0.9, maxWidth: "600px", margin: "4px 0 0 0", lineHeight: 1.5 }}>
              Handcrafted traditional Ayurvedic formulations designed for complete holistic health and daily care.
            </p>
          </div>

          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
              gap: "24px",
              justifyItems: "center",
            }}
          >
            {loading && (
              <div style={{ height: "calc( 60vh ) ", display: "flex", gridColumn: "1 / -1" }}>
                <div style={{ margin: "auto" }}>
                  <Loader />
                </div>
              </div>
            )}
            {!loading &&
              products
                .filter(
                  (x) =>
                    x.name.toLowerCase().includes(search.toLowerCase()) ||
                    x.description.toLowerCase().includes(search.toLowerCase())
                )
                .map((product) => (
                  <ProductCards
                    key={product.id}
                    product={product}
                    handelBuy={() => {
                      if (product.stock == 0) {
                        showMessage({
                          message: `${product.name} out of stock`,
                          type: "error",
                          mode: "auto",
                        })
                      } else {
                        navigate(`/order-summary/${product.id}`)
                      }
                    }}
                    handelCart={() => {
                      if (isLoggedIn) {
                        if (product.stock == 0) {
                          showMessage({
                            message: `${product.name} out of stock`,
                            type: "error",
                            mode: "auto",
                          })
                        } else {
                          dispatch(
                            addToCart({ product_id: product.id, qty: 1 })
                          )
                        }
                      } else {
                        navigate("/login")
                      }
                    }}
                  />
                ))}
          </div>

          {flash && (
            <FlashMessage
              message={flash.message}
              type={flash.type}
              mode={flash.mode}
              onClose={hideMessage}
            />
          )}
        </div>
      </Page>
      {/* <div className={style.productList}> */}
    </>
  )
}

export default Landing
